import { FORM_SECCION } from "../../Constants/Admin";

const str = (v) => (v === null || v === undefined ? "" : String(v));

// Sección de DynamoDB → valores del formulario
export const seccionAForm = (s) => {
  if (!s) return FORM_SECCION;
  const layout = s.layout || {};
  return {
    nombre: str(s.nombre),
    padreId: str(s.padreId),
    eyebrow: str(s.eyebrow),
    navLabel: str(s.navLabel),
    activa: s.activa !== false,
    lista: layout.lista || "tarjetas",
    itemsTitulo: str(s.itemsTitulo),
    itemsTituloDesde: Boolean(s.itemsTituloDesde),
    precios: (s.precios || []).map((p) => ({ etiqueta: str(p.etiqueta), detalle: str(p.detalle), precio: str(p.precio) })),
    mostrarTablaPrecios: Boolean(s.mostrarTablaPrecios),
    tituloTabla: str(s.tituloTabla),
    encabezado: str(s.encabezado),
    descripcion: str(s.descripcion),
    extrasActivo: Boolean(s.extras?.opciones?.length),
    extrasTitulo: str(s.extras?.titulo),
    extrasDestacado: str(s.extras?.destacado),
    extrasOpciones: (s.extras?.opciones || []).map((o) => ({ etiqueta: str(o.etiqueta), precio: str(o.precio), suma: o.suma !== false })),
    imagenes: (s.imagenes || []).map((i) => ({ src: str(i.src), caption: str(i.caption) })),
    overlayActivo: Boolean(s.overlay),
    overlayLabel: str(s.overlay?.label),
    overlaySub: str(s.overlay?.sub),
    fotoLado: layout.fotoLado || "izq",
    anchoFoto: str(layout.anchoFoto || 6),
    fotoTamano: layout.fotoTamano || "normal",
    overlayArriba: Boolean(layout.overlayArriba),
    variante: str(layout.variante),
  };
};

const limpio = (v) => (v || "").trim();

// Valores del formulario → body para la Lambda
export const formASeccion = (v) => ({
  nombre: limpio(v.nombre),
  padreId: v.padreId || null,
  eyebrow: limpio(v.eyebrow) || null,
  navLabel: limpio(v.navLabel) || null,
  activa: v.activa,
  itemsTitulo: limpio(v.itemsTitulo) || null,
  itemsTituloDesde: v.itemsTituloDesde,
  precios: v.precios.map((p) => ({ etiqueta: limpio(p.etiqueta), detalle: limpio(p.detalle), precio: Number(p.precio) })),
  mostrarTablaPrecios: v.mostrarTablaPrecios,
  tituloTabla: limpio(v.tituloTabla) || null,
  encabezado: limpio(v.encabezado) || null,
  descripcion: limpio(v.descripcion) || null,
  extras:
    v.extrasActivo && v.extrasOpciones.length
      ? {
          titulo: limpio(v.extrasTitulo),
          destacado: limpio(v.extrasDestacado),
          opciones: v.extrasOpciones.map((o) => ({ etiqueta: limpio(o.etiqueta), precio: Number(o.precio), suma: o.suma })),
        }
      : null,
  imagenes: v.imagenes.map((i) => ({ src: limpio(i.src), caption: limpio(i.caption) })),
  overlay: v.overlayActivo ? { label: limpio(v.overlayLabel), sub: limpio(v.overlaySub) } : null,
  layout: {
    lista: v.lista,
    fotoLado: v.fotoLado,
    anchoFoto: Number(v.anchoFoto),
    fotoTamano: v.fotoTamano,
    overlayArriba: v.overlayArriba,
    variante: limpio(v.variante) || null,
  },
});
